// App-config context. Kept in a non-component module so the provider file
// exports only components (satisfies react-refresh/only-export-components).

import { createContext, useContext } from "react";
import { DEFAULT_APP_CONFIG, type AppConfig } from "@/api";

export interface AppConfigContextValue extends AppConfig {
  /** `false` until the first fetch settles (success or 404 fallback). */
  loaded: boolean;
}

export const AppConfigContext = createContext<AppConfigContextValue>({
  ...DEFAULT_APP_CONFIG,
  loaded: false,
});

export function useAppConfig(): AppConfigContextValue {
  return useContext(AppConfigContext);
}
